const LIMIT_PAGE = 12

const match = window.location.hash.match(/item_([0-9]+)/)
let focusPage = parseInt(match && 1 in match ? match[1].toString() : '1')

export default {
    data() {
        return {
            category: undefined,
            rendered: false,
            loadNextPage: false,
            posts: [],
            page: this.getPageStarting(),
            next: false
        }
    },
    computed: {
        isNext() {
            return this.$store.getters.isNextPage
        },
        nextPageMessage() {
            return this.$store.getters.getTranslation("next_page") || 'Next';
        }
    },
    methods: {
        storePostsByCategory() {
            if (this.category) {
                return this.$store.getters.filterPostsByCategory(this.category)
            } else {
                let post = this.$store.getters.getPosts

                return [
                    ...post.filter(item => item.isHot || item.isFavorite),
                    ...post.filter(item =>
                      !item.isHot &&
                      !item.isFavorite &&
                      item.category_id !== '1684' &&
                      item.category_id !== '1506' &&
                      item.category_id !== '2021'
                    )
                ]
            }
        },
        getItem() {
            const match = window.location.hash.match(/item_([0-9]+)/)

            return parseInt(match && 1 in match ? match[1].toString() : '1')
        },
        getPageStarting() {
            return Math.floor(focusPage / LIMIT_PAGE) + 1
        },
        goScroll() {
            let itemIndex = focusPage

            if (itemIndex > 3) {
                this.$nextTick(() => {
                    let item = this.$el.querySelectorAll('article')?.[itemIndex]

                    if (item) {
                        window.scrollTo(0, window.scrollY + item.getBoundingClientRect().top - 64)
                    }
                })
            }
        },
        async listRead(limit = 0) {
            let max = this.page * LIMIT_PAGE,
                posts = this.storePostsByCategory(),
                list = this.storePostsByCategory().slice(0, max)

            if (list.length >= max) {
                this.next = posts.length > max
                return list
            } else if (limit < 20 && this.isNext) {
                await this.$store.dispatch('GET_POSTS')
                return this.listRead(limit + 1)
            } else {
                this.next = false
                return list
            }
        },
        async listMounted() {
            this.rendered = false
            this.posts = await this.listRead()
            this.rendered = true
            this.goScroll()
        },
        async listUpdate() {
            this.page++
            this.loadNextPage = true
            this.posts = await this.listRead()
            this.loadNextPage = false
        },
        initEventScroll() {
            let time = undefined
            const listener = () => {
                if (this.$el.closest('body')) {
                    clearTimeout(time)
                    time = setTimeout(() => {
                        let list = this.$el.querySelectorAll('article'),
                            center = 128,
                            focus

                        list.forEach((item, index) => {
                            let rect = item.getBoundingClientRect()

                            if (rect.top <= center) {
                                focus = index
                            }
                        })

                        history.replaceState({page: focus}, undefined, focus > 1 ? `#item_${Math.floor(focus / LIMIT_PAGE) * LIMIT_PAGE}` : '#')
                        time = undefined
                    }, 160)
                } else {
                    window.removeEventListener('scroll', listener)
                }
            }

            setTimeout(() => window.addEventListener('scroll', listener), 320)
        },
        async onNext() {
            await this.listUpdate()

            /*this.$nextTick(() => setTimeout(() => {
                if (navigator.appVersion.match(/Mobile\//)) {
                } else {
                    this.$el.querySelectorAll('article')
                        ?.[(this.page - 1) * LIMIT_PAGE]
                        ?.scrollIntoView({block: "center", behavior: "smooth"})
                }
            }), 400)*/
        }
    }
}
